import * as React from "react";
import type { SVGProps } from "react";
const SvgTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 14a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 21h16a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1 1 1 0 0 1 0-2 1 1 0 0 0 1-1V6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v4a3 3 0 0 0 3 3m-1-3v-3.17a3 3 0 0 0 0-5.66V6a1 1 0 0 1 1-1h10v2a1 1 0 0 0 2 0V5h4a1 1 0 0 1 1 1v3.17a3 3 0 0 0 0 5.66V18a1 1 0 0 1-1 1h-4v-2a1 1 0 0 0-2 0v2H4a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTicket;
